<template>
  <section>
      </br>
      </br>
<div class="admin">			
   <div class="admin-index">
         
      <dl  data-am-scrollspy="{animation: 'slide-right', delay: 100}" class="am-scrollspy-init am-scrollspy-inview am-animation-slide-right">
        <dt class="qs">
            <i class="am-icon-users"></i>
            <!-- <img :src="Iocn"> -->
            </dt>
        <dd >{{Count}}</dd>
        <dd class="f12">剩余短信数量</dd>
      </dl>
      <dl  class="am-animation-slide-right">
        <dt class="cs">
            <i class="am-icon-area-chart"></i>
            </dt>
        <dd>{{Frequency}}</dd>
        <dd class="f12">充值次数</dd>
      </dl>
      <dl  class="am-animation-slide-right">
        <dt class="hs">
            <i class="am-icon-shopping-cart"></i>
            </dt>
        <dd>{{UseCount}}</dd>
        <dd class="f12">已使用短信数量</dd>
      </dl>
      <dl  class="am-animation-slide-right">
        <dt class="ls">
            <i class="am-icon-cny"></i>
            </dt>
        <dd>{{Amount}}</dd>
        <dd class="f12">充值总额</dd>
      </dl>
    </div>
   <div class="admin-biaoge">
      <div class="xinxitj">统计概况</div>
        <el-table  show-summary :data="Detail" highlight-current-row v-loading="listLoading"  style="width: 100%;" >
			<el-table-column prop="Date" label="统计月份 " width="120" sortable :formatter="formatDate">
			</el-table-column>
			<el-table-column prop="Count" label="使用总量" width="115" sortable>
			</el-table-column>
			<el-table-column prop="FrequencyCardCount" label="次卡" width="90" sortable>
			</el-table-column>
			<el-table-column prop="MonthCardCount" label="月卡" width="90" sortable>
			</el-table-column>
			<el-table-column prop="YearCardCount" label="年卡" width="90" sortable>
			</el-table-column>										
	     	<el-table-column prop="TrainingCount" label="培训卡" width="100" sortable>
			</el-table-column>
			<el-table-column prop="RechargeableCardCount" label="充值卡" width="100" sortable>
			</el-table-column>
			<el-table-column prop="OwnerCardCount" label="业主卡" min-width="100" sortable>
			</el-table-column>			
		</el-table>


       <!-- <table class="am-table">
        <thead>
          <tr>
            <th>统计月份</th>
            <th>使用总量</th>
            <th>次卡</th>
            <th>月卡</th>
            <th>年卡</th>
            <th>培训卡</th>
            <th>充值卡</th>
            <th>业主卡</th>
           
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>普卡</td>
            <td>普卡</td>
            <td><a href="#">4534</a></td>
            <td>+20</td>
            <td> 4534 </td>
          </tr>
          <tr>
            <td>银卡</td>
            <td>银卡</td>
            <td>4534</td>
            <td>+2</td>
            <td> 4534 </td>
          </tr>
          <tr>
            <td>金卡</td>
            <td>金卡</td>
            <td>4534</td>
            <td>+10</td>
            <td> 4534 </td>
          </tr>
          <tr>
            <td>钻卡</td>
            <td>钻卡</td>
            <td>4534</td>
            <td>+50</td>
            <td> 4534 </td>
          </tr>
          <tr>
            <td>合计</td>
            <td>合计</td>
            <td>4534</td>
            <td>+50</td>
            <td> 4534 </td>
          </tr>
        </tbody>
      </table>  -->
    </div>
<div class="shuju">
        <div class="xinxitj">短信充值</div>
          <div class="shujutow">
          <ul>
          <h2>短信充值套餐</h2>
          <!-- <li>全盘拨出</li> -->
        </ul>            
        <dl>
          <dt>充值1000元：  短信数量10000条</dt>
          <dt>充值2000元：  短信数量22000条</dt>
          <dt>充值3000元：  短信数量34000条</dt>
           <dt>充值4000元：  短信数量46000条</dt>
          <dt>充值5000元：  短信数量60000条</dt>
         

          <dt><a style="color:red">注意事项</a>： 为了便于短信功能管理，每次充值金额以1000元为单位，如1000元，2000元，以此类推；不要出现充值1500元或者1800元这样的零散金额，谢谢合作</dt>
        </dl>

      </div>
          <div class="xinxitj">收款账户信息</div>
      <div class="shujuone">
          <ul>
          <h2>收款人：陈蒙蒙</h2>
         
          <!-- <li>查看充值记录</li> -->
        </ul>
        <dl>
          <!-- <dt style="color:red"><a @click="">点击查看充值记录</a></dt> -->
           <el-button type="text" class="button" @click="rechargeLog()"><a style="color:red">点击查看历史充值记录</a></el-button>
          <dt>注意事项一：  仅支持支付宝付款</dt>
          <dt>注意事项二：   请在支付备注中注明门店信息</dt>
          <!-- <dt>全盘利润：  546464</dt> -->
          <img style="width:95%" :src="Alipay">
          <dt>&nbsp</dt>
        </dl>
        
      </div>

</div>   
</div>


  	<!-- 充值记录 -->
        <el-dialog  v-model="dialogTableVisible" >
           <el-table :data="ShopRechargeData" highlight-current-row v-loading="logLoading">	
			<el-table-column prop="Count" label="充值数量" width="120" sortable>
			</el-table-column>
			<el-table-column prop="UnitPrice" label="充值单价" width="120" sortable>
			</el-table-column>				
			<el-table-column prop="Money" label="充值金额" width="120" sortable>
			</el-table-column>			
			<el-table-column prop="CreationTime" label="充值时间" min-width="180" sortable>
			</el-table-column>
			<el-table-column prop="Remark" label="备注" min-width="180" sortable>
			</el-table-column>

		    <el-table-column prop="State" label="记录状态"  width="120" sortable fixed="right">  
				  <template slot-scope="scope" >
                  <div slot="reference" class="name-wrapper">
                  <el-tag type="danger" size="medium" v-if="scope.row.State==0">已撤销</el-tag>
                  <el-tag type="success" size="medium" v-else>正常</el-tag>
                  </div>
                  </template>
			</el-table-column>
			<!-- <el-table-column label="操作" width="100" fixed="right">
				<template  slot-scope="scope">
					<el-button type="danger" size="small" :disabled="scope.row.State==0" @click="cancel(scope.$index, scope.row)">撤销充值</el-button>				
				</template>
			</el-table-column> -->
           </el-table>
		   	<el-col :span="24" class="toolbar">
			<el-tag>共有{{logCount}}条充值记录</el-tag>
			<el-pagination layout="prev, pager, next" @current-change="CurrentChange" :page-size="10" :total="logCount" style="float:right;">
			</el-pagination>
	     	</el-col>
        </el-dialog>
  </section>
</template>
<style scoped>
.xinxitj {
    font-size: 16px;
    line-height: 35px;
    border-bottom: solid 1px #c9cdd7;
    margin-bottom: 10px;
}
.shuju {
    float: right;
    width: 37%;
    margin: 5px 1% 0 0;
}
*, :before, :after {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
user agent stylesheet
div {
    display: block;
}
.shujuone {
    width: 100%;
    border-radius: 3px;
    background-color: #42cac0;
    height: 100%;
    overflow: hidden;
    color: #fff;
}
.shujutow {
    width: 100%;
    border-radius: 3px;
    background-color: #a6d669;
    height: 100%;
    overflow: hidden;
    color: #fff;
    margin-top: 15px;
}
.shujutow dl {
    padding: 25px 0 0 35px;
    line-height: 33px;
    color: #fff;
}
.shujutow dt {
    font-weight: 400;
}
.shujutow ul {
    background: #99c262;
    height: 85px;
}
.shujutow h2 {
    font-size: 35px;
    line-height: 85px;
    padding: 0px;
    margin: 0px;
    float: left;
}
.shujutow li {
    float: left;
    line-height: 16px;
    list-style-type: none;
    margin-left: 5px;
    font-size: 16px;
    font-weight: bold;
    margin-top: 47px;
}
*, :before, :after {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
.shujuone dl {
    padding: 25px 0 0 35px;
    line-height: 33px;
    color: #fff;
}
p, hr, ul, ol, dl, blockquote, pre, address, fieldset, figure {
    margin: 0;
}
*, :before, :after {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
.shujuone dt {
    font-weight: 400;
}
dt {
    font-weight: 700;
}
*, :before, :after {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
user agent stylesheet
dt {
    display: block;
}
.shujuone ul {
    background: #39b7ac;
    height: 85px;
}
ul, ol {
    padding-left: 2em;
}
.shujuone h2 {
    font-size: 25px;
    line-height: 85px;
    padding: 0px;
    margin: 0px;
    float: left;
}
h2 {
    font-size: 1.25em;
}
h1, h2, h3, h4, h5, h6 {
    margin: 0 0 1.6rem 0;
    font-weight: 600;
    font-size: 100%;
}
.shujuone li {
    float: left;
    line-height: 16px;
    list-style-type: none;
    margin-left: 5px;
    font-size: 16px;
    font-weight: bold;
    margin-top: 47px;
}
/* --------------------------------- */
.admin-biaoge {
    width: 60%;
    float: left;
    font-size: 14px;
    margin: 0 0 0 1%;
}
*, :before, :after {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
user agent stylesheet
div {
    display: block;
}
.admin-biaoge .xinxitj {
    font-size: 16px;
    line-height: 35px;
    border-bottom: solid 1px #c9cdd7;
    margin-bottom: 10px;
}
.admin-biaoge .am-table {
    background-color: #FFF;
    padding: 3px;
    border-radius: 3px;
    text-align: center;
}
.am-table {
    width: 100%;
    margin-bottom: 1.6rem;
    border-spacing: 0;
    border-collapse: separate;
}
table {
    max-width: 100%;
    background-color: transparent;
    empty-cells: show;
}
table {
    border-collapse: collapse;
    border-spacing: 0;
}
*, :before, :after {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
user agent stylesheet
table {
    display: table;
    border-collapse: separate;
    border-spacing: 2px;
    border-color: grey;
}
tr {
    display: table-row;
    vertical-align: inherit;
    border-color: inherit;
}
thead {
    display: table-header-group;
    vertical-align: middle;
    border-color: inherit;
}
.am-table>caption+thead>tr:first-child>th, .am-table>colgroup+thead>tr:first-child>th, .am-table>thead:first-child>tr:first-child>th, .am-table>caption+thead>tr:first-child>td, .am-table>colgroup+thead>tr:first-child>td, .am-table>thead:first-child>tr:first-child>td {
    border-top: 0;
}
.admin-biaoge .am-table>thead>tr>th {
    text-align: center;
}
.am-table>thead>tr>th {
    vertical-align: bottom;
    border-bottom: 1px solid #ddd;
}
.am-table>thead>tr>th, .am-table>tbody>tr>th, .am-table>tfoot>tr>th, .am-table>thead>tr>td, .am-table>tbody>tr>td, .am-table>tfoot>tr>td {
    padding: .7rem;
    line-height: 1.6;
    vertical-align: top;
    border-top: 1px solid #ddd;
}
th {
    text-align: left;
}
td, th {
    padding: 0;
}
*, :before, :after {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
user agent stylesheet
th {
    font-weight: bold;
}
user agent stylesheet
td, th {
    display: table-cell;
    vertical-align: inherit;
}
/* ---------------------- */

.admin-index {
    width: 100%;
    height: 100px;
    margin-top: 8px;
}
*, :before, :after {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
user agent stylesheet
div {
    display: block;
}
  .admin {
    position: fixed;
    right: 0;
    bottom: 0;
    top: 100px;
    left: 170px;
    overflow-y: auto;
    overflow-x: hidden;
    background-color: #f1f2f7;
}


.admin-index .qs {
    background-color: #6ccac9;
}
.admin-index dt {
    width: 40%;
    float: left;
    line-height: 100px;
    font-size: 45px;
    text-align: center;
    color: #FFF;
}
dt {
    font-weight: 700;
}
*, :before, :after {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
user agent stylesheet
dt {
    display: block;
}
*, :before, :after {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}

Inherited from body

[class*=am-icon-] {
    display: inline-block;

}
.admin-index .f12 {
    font-size: 14px;
    line-height: 16px;
    margin-top: 5px;
}


[class*=am-animation-] {
    -webkit-animation-duration: .5s;
    animation-duration: .5s;
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
}

.am-icon-group:before, .am-icon-users:before {
    content: "\f0c0";
}

.admin-index .cs {
    background-color: #ff6c60;
}
.am-icon-area-chart:before {
    content: "\f1fe";
}
.admin-index .hs {
    background-color: #f8d347;
}
.am-icon-shopping-cart:before {
    content: "\f07a";
}
.admin-index .ls {
    background-color: #57c8f2;
}
.am-icon-cny:before, .am-icon-rmb:before, .am-icon-yen:before, .am-icon-jpy:before {
    content: "\f157";
}

[class*=am-icon-]:before {
    display: inline-block;
    font: normal normal normal 1.6rem/1 FontAwesome,sans-serif;
    font-size: inherit;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-transform: translate(0,0);
    -ms-transform: translate(0,0);
    transform: translate(0,0);
}
*, :before, :after {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
i, cite, em, var, address, dfn {
    font-style: italic;
}
dt {
    font-weight: 700;
}
dt {
    display: block;
}
.admin-index {
    width: 100%;
    height: 100px;
    margin-top: 8px;
}
.cssanimations [data-am-scrollspy*=animation] {
    opacity: 0;
}
.am-animation-slide-right {
    -webkit-animation-name: am-slide-right;
    animation-name: am-slide-right;
    height:100%;
}
.admin-index dd {
    width: 60%;
    text-align: center;
    font-size: 45px;
    line-height: 45px;
    float: right;
    margin-top: 15px;
    color: #c6cad6;
}
dt+dd {
    margin-top: .5em;
}
dd {
    margin-left: 0;
}
*, :before, :after {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
user agent stylesheet
dd {
    display: block;
    -webkit-margin-start: 40px;
}

.cssanimations [data-am-scrollspy*=animation] {
    opacity: 0;
}
.admin-index dl {
    width: 23%;
    margin: 10px 1%;
    background-color: #fff;
    float: left;
    border-radius: 5px;
    overflow: hidden;
}
.am-animation-slide-right {
    -webkit-animation-name: am-slide-right;
    animation-name: am-slide-right;
}
[class*=am-animation-] {
    -webkit-animation-duration: .5s;
    animation-duration: .5s;
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
}
p, hr, ul, ol, dl, blockquote, pre, address, fieldset, figure {
    margin: 0;
}
*, :before, :after {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
user agent stylesheet
dl {
    display: block;
    -webkit-margin-before: 1em;
    -webkit-margin-after: 1em;
    -webkit-margin-start: 0px;
    -webkit-margin-end: 0px;
}
</style>

<script>
// import WeChat from "../../assets/images/WeChat.png"
import Alipay from "../../assets/images/Alipay.png";
import MsgDescription from "../../assets/images/MsgDescription.png";
// import Iocn from "../../assets/images/iocn.png";



	import {mapGetters} from 'vuex';
	import util from '../../common/js/util'

   import {getShopInfor,editshopt,rechargeLogPaging,ShopPayStatistics,ShopPayViewMsgStatistics,MSMConsumeDetail} from  '../../api/api';

export default {
  data() {
    return {
        // WeChat:WeChat,
        	dialogTableVisible:false,
				  ShopRechargeData:[],
				  logCount:0,
				  ShopId:0,
				  logLoading:false,
                  logPage:0,
                  listLoading:false,

        Detail:[],
        Count:0,
        UseCount:0,
        Amount:0,
        Frequency:0,
        Alipay:Alipay,
        MsgDescription:MsgDescription,
        // Iocn:Iocn,
      currentDate: new Date()
    };

  },
  methods:{
      			formatDate: function (row, column) {
				return util.formatDate.format(new Date(row.Date), 'yyyy-MM');
			},
        ConsumeDetail()
        {
          let para ={}
          
          MSMConsumeDetail(para).then((res) => {
                      let {Success,Msg}=res.data;
                     this.Detail=res.data.Data;
					// this.logCount = res.data.TotleCount;
					// this.ShopRechargeData = res.data.Data;
					// this.logLoading=false;
				})
        },
    	CurrentChange(val)
			{
                this.logPage = val;
				this.rechargeLogData();
			},
    	rechargeLog:function(){
				this.dialogTableVisible=true;
				this.ShopRechargeData=[];
				this.rechargeLogData();
			},
			rechargeLogData(){
				let Params = {
					PageIndex: this.logPage-1,					
					PageSize:10,
					ShopId:this.ShopId
				};			
				this.logLoading	=true;  
				  rechargeLogPaging(Params).then((res) => {
					this.logCount = res.data.TotleCount;
					this.ShopRechargeData = res.data.Data;
					this.logLoading=false;
				})
				 .catch(error=>{
                 alert('网络错误');
                });
			},
     ...mapGetters(['getuserstate']),

	   getStoryInfo:function(){
					let para ={
					}
           ShopPayStatistics(para).then((res)=>{
                        let {Success,Msg}=res.data;
						 if(Success)
						 {
						 this.Count=res.data.Data.Count;
                         this.UseCount=res.data.Data.UseCount;
                         this.Amount=res.data.Data.Amount;
                         this.Frequency=res.data.Data.Frequency;                                           
						 }
						 else
						 {
                                this.$message({
									message: Msg,
									type: 'error'
								});
						 }
					 })
		 },
  },
  	 mounted() {
                  let TenancyId=JSON.parse(this.getuserstate()).TenancyId;
          this.ShopId=TenancyId;
            this.getStoryInfo();
            this.ConsumeDetail();
		}
}
</script>



// WEBPACK FOOTER //
// ShopPayView.vue?e5714738